import {ActionType} from "@src/store/ActionType";

export const POST_APPLY = new ActionType("POST_APPLY");
export const GET_APPLICATIONS = new ActionType("GET_APPLICATIONS");
export const PUT_STATUS = new ActionType("PUT_STATUS");
export const POST_INVITE = new ActionType("POST_INVITE");